// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1crH7","info":"PatientInfo_info__36l2h"};